import React from "react";

import { Button, ButtonProps, SxProps } from "@mui/material";

interface ActionButtonProps extends ButtonProps {
  icon?: React.ReactNode;
  active?: boolean;
  sx?: SxProps;
}

const ActionButton = ({
  icon,
  active,
  children,
  sx,
  ...props
}: ActionButtonProps) => {
  return (
    <Button
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        borderRadius: "8px",
        color: "shades.primary.500",
        backgroundColor: active ? "shades.neutral.ghost.600" : "",
        fontWeight: active ? 600 : 500,
        ...sx,
      }}
      {...props}
    >
      {icon && icon}
      {children}
    </Button>
  );
};

export default ActionButton;
